import React from "react";

import styles from "./Moviedetails.module.scss";

import { usePrismicDocumentByUID, PrismicRichText } from "@prismicio/react";
import { useParams } from "react-router-dom";

const Moviedetails = () => {
  const { id } = useParams();

  const [movie] = usePrismicDocumentByUID("movies", `${id}`);

  return (
    <div className={styles.moviedetailsContainer}>
      {movie && (
        <div>
          <img
            src={`${movie.data.coverimage.url}`}
            alt={movie.data.coverimage.url}
            className={styles.image}
          />
          <PrismicRichText className={styles.title} field={movie.data.title} />

          <span className={styles.rating}>Rating: {movie.data.rating}</span>
          <br />
          <div className={styles.category}>
            <span>category:&ensp;</span>
            {movie.data.category.map((category, index) => (
              <p key={index}>{category.name.slug}&emsp;</p>
            ))}
          </div>
          <PrismicRichText
            className={styles.description}
            field={movie.data.description}
          />
        </div>
      )}
    </div>
  );
};

export default Moviedetails;
